import { render } from "./MagentoHeader.vue?vue&type=template&id=1018dbd2"
import script from "./MagentoHeader.vue?vue&type=script&lang=js"
export * from "./MagentoHeader.vue?vue&type=script&lang=js"

import "./MagentoHeader.vue?vue&type=style&index=0&id=1018dbd2&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__